import { getSolidStatusBgColor } from '@odo/shared-ui';
import type { VirtualAppointmentStatus } from '../../services/virtualAppointments';

// SolidStatusPill's hashed colours, except open in green: its shared teal sat next to the DM team teal.
const STATUS_BG_OVERRIDES: Partial<Record<VirtualAppointmentStatus, string>> = {
    open: 'bg-green-600'
};

export function virtualAppointmentStatusBg(status: VirtualAppointmentStatus): string {
    return STATUS_BG_OVERRIDES[status] ?? getSolidStatusBgColor(status);
}
